import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
//components
import { ProfileImage, ChangePassword } from "./";
import style from "./profile.module.scss";
import { red } from "@mui/material/colors";
import CancelRoundedIcon from "@mui/icons-material/CancelRounded";
import VerifiedIcon from "@mui/icons-material/Verified";
import { cyan } from "@mui/material/colors";
import AlertMessage from "../common/AlertMessage";
import { useSelector } from "react-redux";
import ProfileService from "../../../service/profile";
import AppInfoservice from "../../../service/common/Appinfo";
import { FaInfoCircle } from "react-icons/fa";

function Content(props) {
  console.log(props, "props changes");
  const { currentTheme } = useSelector((state) => state.Theme);
  const { t } = useTranslation();
  const notifyInintialState = {
    show: false,
    message: "",
    type: "",
    header: "",
  };
  //state
  const [state, setState] = useState({
    modal: {
      show: false,
      modalType: "",
      icon: "",
    },
    notify: notifyInintialState,
    isSuccess: false,
  });

  const [uploadedData, setUploadedData] = useState(null);
  const [kycDocs, setKycDocs] = useState([]);
  const fetchData = async () => {
    const service = new AppInfoservice();
    const res = await service.get_layout();
    if (res) {
      setUploadedData(res.data.uploaded); // Set the response to the state
      setKycDocs(res.data.docs);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const history = useHistory();

  useEffect(() => {}, [state.modal.type, props]);
  let service = new ProfileService();

  const [selectedOption, setSelectedOption] = useState("");

  const handleDropdownChange = async (event) => {
    const selectedValue = event.target.value;
    console.log(" ==== selected value", selectedValue);
    setSelectedOption(selectedValue);
    const requestBody = {
      activation_type: selectedValue,
    };
    try {
      let result = await service.updateActivationSettings(requestBody);
      console.log(result, "activation settings updation");
      if (result.status) {
        messageShowForNotify(
          "success",
          "Success",
          "Activation settings updated successfully"
        );
      } else {
        messageShowForNotify(
          "error",
          "Error",
          result.error?.description ? result.error?.description : ""
        );
      }
    } catch (error) {
      messageShow("error", "Error", "Failed to update activation settings");
    }
  };

  //state variable
  const { modal } = state;

  //changepassowrd button click
  const changeButtonClick = (modalType) => {
    let icon = "fa fa-key";
    if (modalType === "changePassword") {
      icon = "fa fa-lock";
    }
    setState((prev) => ({
      ...prev,
      modal: {
        ...prev.modal,
        show: true,
        modalType: modalType,
        icon: icon,
      },
    }));
    if (modalType === "verifyYourAccount") {
      if (modalType === "verifyYourAccount") {
        icon = "fa fa-lock";
      }
      setState((prev) => ({
        ...prev,
        modal: {
          ...prev.modal,
          show: true,
          modalType: modalType,
          icon: icon,
        },
      }));
    }
  };

  //onclose model
  const closeModal = () => {
    setState((prev) => ({
      ...prev,
      modal: {
        ...prev.modal,
        show: false,
        modalType: "",
      },
      isSuccess: false,
    }));
  };

  //on dismiss notify
  const notifyDissmissed = () => {
    setState((prev) => ({
      ...prev,
      notify: notifyInintialState,
    }));
  };

  //show totify message
  const messageShow = (type, header, message) => {
    setState((prev) => ({
      ...prev,
      modal: {
        ...prev.modal,
        show: type === "success" ? false : true,
      },
      isSuccess: type === "success" ? true : false,
      notify: {
        ...prev.notify,
        show: true,
        type: type,
        header: header,
        message: message,
      },
    }));
  };

  const messageShowForNotify = (type, header, message) => {
    setState((prev) => ({
      ...prev,
      notify: {
        ...prev.notify,
        show: true,
        type: type,
        header: header,
        message: message,
      },
    }));
  };
  const showNotify = (type, header, message) => {
    setState((prev) => ({
      ...prev,
      modal: {
        ...prev.modal,
        show: type === "success" ? false : type === "error" ? false : true,
      },
      notify: {
        ...prev.notify,
        show: true,
        type: type,
        header: t(header),
        message: t(message),
      },
    }));
  };

  return (
    <div className={style.ProfileDetails}>
      <div
        className={`${
          currentTheme == "theme-dark"
            ? `${style.dark_mode_panel}`
            : `${style.panel}`
        }`}
      >
        <div className={style.profileUser}>
          <div className={style.ProfileSection}>
            <div className={style.MainProfileDetails}>
              <ProfileImage
                image={props.profile.user_photo}
                date={props.profile?.membership_package?.product_validity?.date}
                notify={showNotify}
                getData={props.getData}
                onDeletePic={props.onDeletePic}
              />

              <h3
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_ProfileFullName}`
                    : `${style.ProfileFullName}`
                }`}
              >
                {props.profile.full_name}
              </h3>
              <h5
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_ProfileUserName}`
                    : `${style.ProfileUserName}`
                }`}
              >
                {props.profile.user_name}
              </h5>
              {props.profile.hasOwnProperty("kyc_status") && (
                <div
                  className={`${
                    currentTheme == "theme-dark"
                      ? `${style.dark_mode_kyc}`
                      : `${style.kyc}`
                  }`}
                >
                  <div>
                    {props.profile.kyc_status ? (
                      <span className={style.Verified}>
                        <VerifiedIcon
                          sx={{ color: cyan[300] }}
                          fontSize="small"
                        />
                        {t("Common.verified")}
                      </span>
                    ) : (
                      <div>
                        <span className={style.notVerified}>
                          <CancelRoundedIcon
                            sx={{ color: red[500] }}
                            fontSize="small"
                          />{" "}
                          <small>{t("Common.notverified")}</small>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              )}
              {!uploadedData && (
                <span
                  onClick={() => {
                    changeButtonClick("verifyYourAccount");
                  }}
                  className={`${
                    currentTheme == "theme-dark"
                      ? `${style.dark_mode_PasswordButton}`
                      : `${style.PasswordButton}`
                  }`}
                >
                  {t("Common.verifyYourAccount").toUpperCase()}
                </span>
              )}

              <span
                onClick={() => {
                  changeButtonClick("changePassword");
                }}
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_PasswordButton}`
                    : `${style.PasswordButton}`
                }`}
              >
                {t("Common.changepswd").toUpperCase()}
              </span>
              <span
                onClick={() => {
                  changeButtonClick("manageSubscription");
                }}
                className={`${
                  currentTheme == "theme-dark"
                    ? `${style.dark_mode_PasswordButton}`
                    : `${style.ManageButton}`
                }`}
              >
                MANAGE SUBSCRIPTION
              </span>
            </div>
          </div>
          <div>
            <div class="container">
              <div class="row">
                <div class="col-md-6">
                  <h5 class="font-weight-bold">Account Details</h5>
                  <div class="form-group">
                    <label for="sponsorInput">Sponsor:</label>
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      id="sponsorInput"
                      value={props.profile.sponsor_name}
                      disabled
                    />
                  </div>
                  <div class="form-group">
                    <label for="placementInput">Placement:</label>
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      id="placementInput"
                      value={props.profile.placement}
                      disabled
                    />
                  </div>
                  <div class="form-group">
                    <label for="positionInput">Placement Position:</label>
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      id="positionInput"
                      value={props.profile.placement_position}
                      disabled
                    />
                  </div>
                  <div class="form-group">
                    <label for="countryInput">Registration Country:</label>
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      id="countryInput"
                      value={props.profile.reg_country}
                      disabled
                    />
                  </div>
                  <div class="form-group">
                    <label for="countryInput">Current Rank:</label>
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      id="countryInput"
                      value={props?.profile?.rank?.curent_rank}
                      disabled
                    />
                  </div>
                  <div class="form-group">
                    <label for="activationInput">
                      Activation Settings:{" "}
                      <FaInfoCircle
                        size={"1.5rem"}
                        color="black"
                        data-toggle="tooltip"
                        title="Activation Info : When you are tagged under 'MANUAL ACTIVATE' all product reorders for the month's personal maintenance will be manually activated. This action will provide GSR income to your upline's unilevel tree"
                      />
                    </label>
                    <select
                      class="form-control form-control-xs"
                      value={selectedOption}
                      onChange={handleDropdownChange}
                      id="my-dropdown"
                      name="color"
                    >
                      {props.profile.activationSettings === "Manual" ? (
                        <>
                          <option value="Manual">Manual</option>
                          <option value="Automatic">Automatic</option>
                        </>
                      ) : (
                        <>
                          <option value="Automatic">
                            {props.profile.activationSettings}
                          </option>
                          <option value="Manual">Manual</option>
                        </>
                      )}
                    </select>
                  </div>
                </div>

                <div class="col-md-6">
                  <h5 class="font-weight-bold">Account Type</h5>
                  <div class="form-group">
                    <label for="accountType">Account Type:</label>
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      id="accountType"
                      value={props.accountType.accountType}
                      disabled
                    />
                  </div>
                  <div class="form-group">
                      <label for="businessNameInput">Business Name:</label>
                      <input
                          type="text"
                          class="form-control form-control-xs"
                          id="businessNameInput"
                          value={props.accountType.businessName}
                          disabled
                      />
                  </div>
                  {/* 3.1 Payee Name */}
                  <div class="form-group">
                      <label for="payeeNameInput">Payee Name:</label>
                      <input
                          type="text"
                          class="form-control form-control-xs"
                          id="payeeNameInput"
                          value={props?.accountType?.payeeName ?? "N/A"}
                          disabled
                      />
                  </div>
                  {/* 3.2 TIN */}
                  <div class="form-group">
                      <label for="tinNumberInput">Tax Identification Number (TIN):</label>
                      <input
                          type="text"
                          class="form-control form-control-xs"
                          id="tinNumberInput"
                          value={props?.accountType?.tinNumber ?? "N/A"}
                          disabled
                      />
                  </div>
                  <div class="form-group">
                      <label for="extensionCheckbox">Extension Account?</label>
                    <div class="form-check">
                      <input
                        class="form-check-input"
                        type="checkbox"
                        id="extensionCheckbox"
                        checked={props.accountType.extensionStatus}
                        disabled
                      />
                      <label class="form-check-label" for="extensionCheckbox">
                        Check if this account is an extension
                      </label>
                    </div>
                  </div>
                  <div class="form-group">
                    <label for="primaryUsernameInput">
                      Primary Account Username:
                    </label>
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      id="primaryUsernameInput"
                      value={props?.accountType?.primaryUserName}
                      disabled
                    />
                  </div>
                  <div class="form-group">
                    <label for="primaryUsernameInput">Advance Rank</label>
                    <input
                      type="text"
                      class="form-control form-control-xs"
                      id="primaryUsernameInput"
                      value={props?.profile?.intermediateRank?.name}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChangePassword
        {...modal}
        onClose={closeModal}
        setNotify={messageShow}
        showNotify={showNotify}
        policy={props.profile.password_policy}
        checkKyCsubmitstatus={props.checkKyCsubmitstatus}
        kycDocs={kycDocs}
        sms={props.profile.smsBlast}
        smsContent={props.profile.smsContent}
      />
      {state.notify.show && (
        <AlertMessage
          type={state.notify.type}
          message={state.notify.message}
          show={state.notify.show}
          dismiss={notifyDissmissed}
        />
      )}
    </div>
  );
}

export default Content;
